import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, Suspense as _Suspense, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-px hidden invisible" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AuthLoginDialog = _resolveComponent("AuthLoginDialog")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Drawer = _resolveComponent("Drawer")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Editor = _resolveComponent("Editor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_metainfo, null, {
      title: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content ? `${content} | eGesparc` : `eGesparc`), 1)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        }))
      ]),
      _: 1
    })),
    _createVNode(_component_AuthLoginDialog),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, { class: "hidden invisible" }),
      _createVNode(_component_InputText, { class: "hidden invisible" }),
      _createVNode(_component_Password, {
        class: "hidden invisible",
        "input-props": { readonly: true }
      }),
      _createVNode(_component_Divider, { class: "hidden invisible" }),
      _createVNode(_component_Card, { class: "hidden invisible" }),
      _createVNode(_component_Drawer, { class: "hidden invisible" }),
      _createVNode(_component_Toolbar, { class: "hidden invisible" }),
      _createVNode(_component_Editor, { class: "hidden invisible" })
    ])
  ], 64))
}